import axios from 'axios'
import auth from '@/auth'
import store from '@/store'
import common from './common'
import HttpStatus, { getStatusText } from '@/components/http-status'
import { UniqError } from '@/classes'

function getCookie(name) {
  let nameValues = {}
  let cookies = document.cookie.split(';')
  for (let cookie of cookies) {
    let [name, value] = cookie.split('=', 2)
    if (value && name) {
      nameValues[name.trim()] = value.trim()
    }
  }

  return nameValues[name]
}

const token = getCookie('UniqApi.Token')
const service = axios.create({
  baseURL: process.env.VUE_APP_WEBAPI_URI,
  responseType: 'arraybuffer',
  headers: {
    Authorization: token ? 'Bearer ' + token : ''
  }
})

service.interceptors.request.use(
  config => {
    setAuthHeader(config)
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  function (response) {
    common.setUnauthorized(false)
    return response
  },
  function (error) {
    store.dispatch('$resetSpinner')
    if (common.isExpiredToken(error)) {
      common.sentryLogError(error, 'isExpiredToken')
      common.setUnauthorized(true)
      return common.refreshToken(error)
    } else if (common.isInvalidToken(error)) {
      common.sentryLogError(error, 'isInvalidToken')
      common.setUnauthorized(true)
      auth.logout()
    } else if (error && error.response && error.response.status && error.response.status === HttpStatus.INTERNAL_SERVER_ERROR) {
      if (error.response.data instanceof ArrayBuffer) {
        const result = common.parseArrayBufferErrorResponse(error.response.data)
        store.dispatch('errors/add', result)
      } else {
        store.dispatch('errors/add', error.response.data)
      }
      common.sentryLogError(error, statusCodes[HttpStatus.INTERNAL_SERVER_ERROR])
      return Promise.reject(error)
    } else {
      const status = error.response ? error.response.status : ''
      const statusText = error.response ? error.response.statusText : ''
      const url = error.response ? error.response.config.url : ''
      const e = new UniqError(0, statusText, status, url, error.response.data)
      store.dispatch('errors/add', e)
      common.sentryLogError(error, getStatusText(status))
      return Promise.reject(error)
    }
  }
)

/**
 * Set the Authorization header on a Axios Request.
 *
 * @param {Request} request The Axios Request instance to set the header on.
 * @return {void}
 */
function setAuthHeader(config) {
  const token = getCookie('UniqApi.Token')
  config.headers.Authorization = token ? 'Bearer ' + token : ''
}

export default service
